import * as moment from 'moment'

const autocastsReportModule = {
  namespaced: true,

  state: {
    loading: false,
    allEmails: [],
    allEmailsInfo: [],
    period: { start: null, end: null },
    ordersSum: 0,
    pagination: { perPage: 10, page: 1 }
  },

  mutations: {
    setAllMessages: (state, allEmails) => (state.allEmails = allEmails),
    setMessagesInfo: (state, allEmailsInfo) => (state.allEmailsInfo = allEmailsInfo),
    setLoading: (state, loading) => (state.loading = loading),
    setPeriod: (state, period) => (state.period = JSON.parse(JSON.stringify(period))),
    setOrdersSum: (state, orders_sum) => (state.ordersSum = orders_sum),
    setPagination: (state, pagination) => (state.pagination = pagination),
    updateMessagesInfo: (state, infoToAdd) => {
      state.allEmailsInfo = state.allEmailsInfo.reverse()
        for(let i = 0; i < infoToAdd.length; i++){
          state.allEmailsInfo[i].orders_count = infoToAdd[i].orders_count
        }
    },

  },

  getters: {
    getAll: (state) => (period) => {
      if (!state.allEmails.length) return state.allEmails
      if (!period) return state.allEmails

      return state.allEmails.filter(
        (ac) =>
          new Date(ac.sent).getTime() >= new Date(period.start).getTime() &&
          new Date(ac.sent).getTime() <= new Date(period.end).getTime()
      )
    },

    getAllIds: (_, getters) => (period) => {
      if (!getters.getAll(period).length) return null

      return getters.getAll(period).reduce((acc, item) => {
        acc.push(item.id)

        return acc
      }, [])
    },

    getData: (state, getters) => {
      return getters.getAll(state.period).reduce((acc, item) => {
        const messageInfo = {}

        const info = state.allEmailsInfo.find((info) => info.id === item.id)

        if (!info) return acc

        messageInfo.name = info.name
        messageInfo.count = info.email_stats[0].count
        messageInfo.delivered = info.email_stats[0].delivered
        messageInfo.opened = info.email_stats[0].opened
        messageInfo.clicked = info.email_stats[0].clicked
        messageInfo.sent = moment(info.sent).format('DD.MM.YYYY HH:mm:ss')
        messageInfo.id = info.id
        messageInfo.orders_count = info.orders_count
        messageInfo.opened_percent = info.email_stats[0].opened_percent
        messageInfo.unsubscribed_percent = info.email_stats[0].unsubscribed_percent
        messageInfo.clicked_percent = info.email_stats[0].clicked_percent

        acc.push(messageInfo)

        return acc
      }, [])
    }
  }
}

export default autocastsReportModule



// WEBPACK FOOTER //
// ./src/store/modules/reports/modules/emails/modules/email_campaigns.js